/**
 * Thin wrapper around PostHog so the app can fire analytics events without
 * hard-dependencies on the global. PostHog is loaded via the snippet in
 * `public/index.html`; this module just provides safe no-op behaviour when
 * it hasn't finished initialising (or is blocked by an ad-blocker).
 *
 * Usage:
 *   import { track, identify } from "../lib/analytics";
 *   track("game_won", { placement: 1, difficulty: "medium" });
 *   identify(userId, { email });
 */

function ph() {
  try {
    return (typeof window !== "undefined" && window.posthog) || null;
  } catch {
    return null;
  }
}

export function track(event, props) {
  const p = ph();
  if (!p || typeof p.capture !== "function") return;
  try { p.capture(event, props || {}); } catch {}
}

export function identify(userId, props) {
  const p = ph();
  if (!p || !userId) return;
  try { p.identify(userId, props || {}); } catch {}
}

export function resetAnalytics() {
  const p = ph();
  if (!p) return;
  try { p.reset(); } catch {}
}
